import Repository from "./repository"

export default {
    /**
     * S20201_ご契約内容表示
     *
     * @param {object} params リクエストパラメータ
     */
    get(params) {
        return Repository.get('/api/s202-neo-contract-details/view', { params: params })
    }
}